module.exports = __webpack_public_path__ + "img/e22172a274c5b3d5dc5d61fe87927c97.e22172a2.png";